import * as Sentry from "@sentry/react";

/**
 * Where the Navigator reports errors that an engineer must see. The Navigator
 * provider receives it as a prop, so tests pass a fake without module mocking.
 */
export interface NavigatorLog {
  /** `message` is stable, so equal errors group together. */
  error(message: string, extra: Record<string, unknown>): void;
}

/** The real log: the browser console and Sentry. */
export const sentryNavigatorLog: NavigatorLog = {
  error: (message, extra) => {
    console.error(message, extra);
    Sentry.captureMessage(message, { level: "error", extra });
  },
};
